import * as THREE from 'three';

export function addLights(scene) {
  let light;

  light = new THREE.DirectionalLight(0xffffff, 0.2);
  light.position.set(100, 200, 30);
  scene.add(light);

  light = new THREE.DirectionalLight(0xffffff, 0.2);
  light.position.set(-200, -100, 300);
  scene.add(light);

  light = new THREE.DirectionalLight(0xffffff, 0.2);
  light.position.set(100, 200, -30);
  scene.add(light);

  light = new THREE.DirectionalLight(0xffffff, 0.2);
  light.position.set(-200, -100, -300);
  scene.add(light);

  light = new THREE.AmbientLight(0xffffff, 0.8);
  scene.add(light);
}
